<template>
  <notifications group="messages" />
</template>

<!-- The `.v-fade-left-*` transition classes are defined globally in src/scss/vue.scss -->

<script>
import Vue from 'vue'
import Notifications from 'vue-notification'

Vue.use(Notifications)

export default {}
</script>
